module.exports = __webpack_public_path__ + "media/images/companyPage/integrity-bc884b763eb76a22a7f9c6e5b02f7e05.svg";